import React from 'react';
import { Space, Card, Button, Form, Divider, Flex } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import InputNumber from 'components/input-number';
import ProductOptionPicker from 'components/pickers/product-option';
import AtrributePicker from './AttributePicker';
import ImagePicker from 'components/pickers/image/ImagePicker';

const Mobile = ({ viewModel, embedded = false }) => {
  const {
    id,
    form,
    options,
    productOptions,
    sortedVariants,
    filteredOptions,
    navigate,
    onFinish,
    onFinishFailed,
    loadProductOptions,
    onSelectOptionChange,
    onUpdateProductVariant,
    onGroupImageChange,
    onVariantImageChange,
    onVariantOriginalPriceChange,
    attributeChange,
    removeOption,
    setAllVariantPrice,
  } = viewModel;

  return (
    <Form
      form={form}
      name="basic-mobile"
      initialValues={{ remember: true }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
    >
      <Space direction="vertical" size={12} style={{ width: '100%', paddingBottom: embedded ? 0 : 96 }}>
        <Card size="small" title="Biến thể">
          <Space direction="vertical" size={12} style={{ width: '100%' }}>
            {options.map((x) => {
              if (x.id == 'default') {
                return null;
              }

              return (
                <div key={x.id}>
                  <label>{x.title}</label>
                  <div style={{ display: 'flex', flexDirection: 'row', gap: 8 }}>
                    <div style={{ flexGrow: 1 }}>
                      <ProductOptionPicker value={x.values} id={x.id} onChange={onSelectOptionChange} onAddNewValue={loadProductOptions} />
                    </div>
                    <div>
                      <Button onClick={() => removeOption(x.id)} type="text" icon={<DeleteOutlined />} />
                    </div>
                  </div>
                </div>
              );
            })}

            <AtrributePicker onChange={attributeChange} value={options.map((x) => x.id)} onOptionAdded={loadProductOptions} />

            <div>
              <label>Giá tất cả biến thể</label>
              <InputNumber style={{ width: '100%' }} onChange={(e) => setAllVariantPrice(e)} />
            </div>

            {(() => {
              const opt0 = filteredOptions?.[0];

              if (!opt0) {
                return (sortedVariants || []).map((variant) => (
                  <div key={variant?.variant_id || variant?.id}>
                    <Space direction="vertical" size={8} style={{ width: '100%' }}>
                      <div>
                        <b>Hình ảnh:</b>
                        <div style={{ marginTop: 6 }}>
                          <ImagePicker value={variant.image} onChange={(e) => onVariantImageChange(e, variant.variant_id)} />
                        </div>
                      </div>

                      <div>
                        <b>Giá:</b>
                        <div style={{ marginTop: 6 }}>
                          <InputNumber style={{ width: '100%' }} value={variant.original_price} onChange={(e) => onVariantOriginalPriceChange(e, variant.variant_id)} />
                        </div>
                      </div>
                    </Space>
                    <Divider style={{ margin: '12px 0' }} />
                  </div>
                ));
              }

              const getOptionTitle = (optionId, valueId) => {
                const optDef = productOptions.find((x) => x.id === optionId);
                return optDef?.values?.find((x) => x.id === valueId)?.title || valueId || '-';
              };

              const groups = [];
              const groupMap = {};

              (sortedVariants || []).forEach((variant) => {
                const opt0Value = variant.options?.find((o) => o.id === opt0.id)?.value;
                const key = String(opt0Value || '');
                if (!groupMap[key]) {
                  groupMap[key] = {
                    key,
                    opt0Value,
                    title: getOptionTitle(opt0.id, opt0Value),
                    image: variant.image || null,
                    variants: [],
                  };
                  groups.push(groupMap[key]);
                }
                if (!groupMap[key].image && variant.image) {
                  groupMap[key].image = variant.image;
                }
                groupMap[key].variants.push(variant);
              });

              return groups.map((group) => (
                <Card key={group.key} size="small" title={group.title}>
                  <Space direction="vertical" size={8} style={{ width: '100%' }}>
                    <div>
                      <b>Hình ảnh:</b>
                      <div style={{ marginTop: 6 }}>
                        <ImagePicker value={group.image} onChange={(e) => onGroupImageChange(e, opt0.id, group.opt0Value)} />
                      </div>
                    </div>

                    {(group.variants || []).map((variant, index) => (
                      <div key={variant?.variant_id || variant?.id}>
                        <Space direction="vertical" size={6} style={{ width: '100%' }}>
                          {filteredOptions.slice(1).map((opt, idx) => {
                            const variantOpt = variant.options?.find((o) => o.id === opt.id);
                            const value = getOptionTitle(opt.id, variantOpt?.value);
                            return (
                              <div key={`${variant?.variant_id}-${opt.id}`}>
                                <b>{opt.title || `Thuộc tính ${idx + 2}`}:</b> {value}
                              </div>
                            );
                          })}

                          <div>
                            <b>Giá:</b>
                            <div style={{ marginTop: 6 }}>
                              <InputNumber style={{ width: '100%' }} value={variant.original_price} onChange={(e) => onVariantOriginalPriceChange(e, variant.variant_id)} />
                            </div>
                          </div>
                        </Space>
                        {index < group.variants.length - 1 && <Divider style={{ margin: '12px 0' }} />}
                      </div>
                    ))}
                  </Space>
                </Card>
              ));
            })()}

          </Space>
        </Card>
      </Space>

      {embedded ? (
        <Flex justify='flex-end'>
          <Button type="primary" onClick={onUpdateProductVariant}>
            Cập nhật biến thể
          </Button>
        </Flex>
      ) : (
        <div
          style={{
            position: 'fixed',
            left: 12,
            right: 12,
            bottom: 12,
            zIndex: 1000,
            background: '#fff',
            border: '1px solid #f0f0f0',
            borderRadius: 12,
            padding: 12,
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
          }}
        >
          <Space style={{ width: '100%', justifyContent: 'space-between' }}>
            <Button onClick={() => navigate(`/product/edit/${id}`)}>Back</Button>
            <Button type="primary" onClick={onUpdateProductVariant}>
              Cập nhật
            </Button>
          </Space>
        </div>
      )}
    </Form>
  );
};

export default Mobile;

